import {Http} from '@/model/Http.js'

export default class pay extends Http {
  
  productExport(data) {
    const url = '/movie/xhs/mini/product/export'
    return this.postAjaxByMiniNew(url, data)
  }
  
  productAddOrEdit(data) {
    const url = '/movie/xhs/mini/product/insert-or-update'
    return this.postAjaxByMiniNew(url, data)
  }
  
  productionPage(data) {
    const url = '/movie/xhs/mini/product/page'
    return this.postAjaxByMiniNew(url, data)
  }
  
  homeSort(data) {
    const url = '/movie/xhs/mini/product/homeSort'
    return this.postAjaxByMini(url, data)
  }
  
  productOff(data){
    const url = '/movie/xhs/mini/product/off'
    return this.postAjaxByMini(url, data)
  }
  
  productUp(data){
    const url = '/movie/xhs/mini/product/up'
    return this.postAjaxByMini(url, data)
  }
  
  productSync(data) {
    const url = '/movie/xhs/mini/product/sync'
    return this.postAjaxByMini(url, data)
  }
  
  productDelete(data) {
    const url = '/movie/xhs/mini/product/delete'
    return this.postAjaxByMini(url, data)
  }
  
  productDetail(data) {
    const url = '/movie/xhs/mini/product/get-product-detail'
    return this.postAjaxByMini(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/api/xhs.js